export default function PlayNextIcon({ className="", onClick=null }) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
    >
      <path d="M328.32,153.98h-20.88c-3.47,0-6.28,2.81-6.28,6.28v71.31l-126.45-73.01c-4.14-2.39-9.31.6-9.31,5.38v172.12c0,4.78,5.17,7.77,9.31,5.38l126.45-73.01v71.31c0,3.47,2.81,6.28,6.28,6.28h20.88c3.47,0,6.28-2.81,6.28-6.28v-179.48c0-3.47-2.81-6.28-6.28-6.28Z"/>
    </svg>
  );
}
